export const SalesEndpoints = {
    branchComparison: () => '/sales/branch-comparison',
    hourlyActivity: () => '/sales/hourly-activity',
    revenueDynamics: () => '/sales/revenue-dynamics',
    revenueSummary: () => '/sales/revenue-summary',
    salesTransactions: () => '/sales/transactions',
    topBrands: () => '/sales/top-brands',
    topCategories: () => '/sales/top-categories',
    topProducts: () => '/sales/top-products',
};
